export const PRINT_WITH_PRICE = 'PRINT_WITH_PRICE';
export const PRINT_WITHOUT_PRICE = 'PRINT_WITHOUT_PRICE';
export const WINDOW_PRINT_TRIGGERED = 'WINDOW_PRINT_TRIGGERED';
export const printActions = {
    printWithPrice: () => ({ type: PRINT_WITH_PRICE }),
    printWithoutPrice: () => ({ type: PRINT_WITHOUT_PRICE }),
    windowPrintTriggered: () => ({ type: WINDOW_PRINT_TRIGGERED }),
};
